import debounce from 'lodash.debounce';
import {
  LinearProgress,
  RaisedButton,
  FlatButton,
  Checkbox,
  TextField as MUITextField,
  List as MUIList,
  ListItem
} from 'material-ui';
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import get from 'lodash.get';
import {
  URL_USER_PROJECTS,
  URL_PROJECTS,
  URL_USER_PROJECTS_CHANGE
} from '../constants';
import fetcher from '../helpers/fetcher';

const UserProjectsField = props => {
  const id = props.record.id;
  const role = props.record.role;
  const PER_PAGE = 20;
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reloadProjects, setReloadProjects] = useState(0);
  const [skip, setSkip] = useState(0);
  const [projectIdsToAdd, setProjectIdsToAdd] = useState([]);
  const [projectIdsToRemove, setProjectIdsToRemove] = useState([]);
  const [availableProjects, setAvailableProjects] = useState([]);
  const [filter, setFilter] = useState('');
  useEffect(() => {
    let url = `${URL_USER_PROJECTS}?userId=${id}&role=${role}`;
    setLoading(true);
    fetcher.get(url).then(res => {
      setProjects(get(res, 'data.data', []));
      setLoading(false);
    });
  }, [reloadProjects]);
  const loadAvailableProjectsDebounced = useRef(
    debounce(query => {
      setLoading(true);
      fetcher.get(URL_PROJECTS, { params: query }).then(res => {
        setAvailableProjects(get(res, 'data.data', []));
        setLoading(false);
      });
    }, 500)
  ).current;
  useEffect(() => {
    setProjectIdsToAdd([]);
    const query = { where: {}, limit: PER_PAGE, skip: skip };
    if (projects.length) {
      query.where.id = { '!': projects.map(p => p.id) };
    }
    if (filter) {
      query.where.name = { like: '%' + filter + '%' };
    }
    loadAvailableProjectsDebounced(query);
  }, [filter, skip, projects]);
  const onCheckboxChange = (e, data, setter) => {
    const projectId = ~~e.target.getAttribute('data-id');
    if (e.target.checked) {
      if (data.indexOf(projectId) === -1) {
        setter([...data, projectId]);
      }
    } else {
      if (data.indexOf(projectId) > -1) {
        setter(data.filter(id => id != projectId));
      }
    }
  };
  const onButtonClick = (action, data, setter) => {
    setLoading(true);
    fetcher
      .post(URL_USER_PROJECTS_CHANGE, {
        projectIds: data,
        userId: id,
        action: action
      })
      .then(() => {
        setter([]);
        setReloadProjects(reloadProjects + 1);
        setLoading(false);
      });
  };
  const onFilterChange = (e, value) => {
    setFilter(value);
  };
  const onRemoveCheckboxChange = e =>
    onCheckboxChange(e, projectIdsToRemove, setProjectIdsToRemove);
  const onAddCheckboxChange = e =>
    onCheckboxChange(e, projectIdsToAdd, setProjectIdsToAdd);
  const onRemoveClick = () =>
    onButtonClick('remove', projectIdsToRemove, setProjectIdsToRemove);
  const onAddClick = () =>
    onButtonClick('add', projectIdsToAdd, setProjectIdsToAdd);
  const onNextClick = () => setSkip(skip + PER_PAGE);
  const onPrevClick = () => setSkip(Math.max(skip - PER_PAGE, 0));

  if (role === 'agent') {
    return (
      <div>
        {loading && <LinearProgress />}
        <h2>Current Projects</h2>
        <MUIList>
          {projects.map(project => (
            <ListItem
              primaryText={
                <Link
                  to={{
                    pathname: `/projects/${project.id}`
                  }}
                >
                  {project.name || project.id}
                </Link>
              }
            />
          ))}
        </MUIList>
      </div>
    );
  } else if (role === 'customer') {
    return (
      <div>
        {loading && <LinearProgress />}
        <h2>Current Projects</h2>
        <MUIList>
          {projects.map(project => (
            <ListItem
              primaryText={`${project.name || `(${project.id})`}`}
              leftCheckbox={
                <Checkbox
                  checked={projectIdsToRemove.indexOf(project.id) > -1}
                  data-id={project.id}
                  onCheck={onRemoveCheckboxChange}
                />
              }
            />
          ))}
        </MUIList>
        <RaisedButton
          onClick={onRemoveClick}
          disabled={loading}
          label="Remove"
        />
        <h2>Available Projects</h2>
        <MUITextField
          // onChangex={(e, value) => setFilter(value)}
          onChange={onFilterChange}
          value={filter}
          hintText="Enter text to filter"
          floatingLabelText="Filter available projects"
        />
        <p>
          Note: Showing only first {PER_PAGE} results. Please use the filter to
          get to the projects you want if they are not in the list below
        </p>
        {availableProjects.length === 0 ? <p>No projects found</p> : ''}
        <MUIList>
          {availableProjects.map(project => (
            <ListItem
              primaryText={`${project.name || `(${project.id})`}`}
              leftCheckbox={
                <Checkbox
                  checked={projectIdsToAdd.indexOf(project.id) > -1}
                  data-id={project.id}
                  onCheck={onAddCheckboxChange}
                />
              }
            />
          ))}
        </MUIList>
        <div style={{ display: 'none' }}>
          <FlatButton onClick={onPrevClick} label="Prev" />
          <span>Page {Math.floor(skip / PER_PAGE) + 1}</span>
          <FlatButton onClick={onNextClick} label="Next" />
        </div>
        <RaisedButton onClick={onAddClick} disabled={loading} label="Add" />
      </div>
    );
  }
  return null;
};

UserProjectsField.defaultProps = {
  addLabel: true
};

export default UserProjectsField;



// WEBPACK FOOTER //
// ./src/components/UserProjectsField.js